import { TableRow } from "@/components/ui/table";
import { CompetitiveMetricRow } from "../CompetitiveMetricRow";
import { URLAnalysis } from "@/types/seo";

interface ContentMetricsProps {
  urlAnalyses: URLAnalysis[];
}

export const ContentMetrics = ({ urlAnalyses }: ContentMetricsProps) => (
  <>
    <CompetitiveMetricRow
      label="Título"
      description="Título da página (tag title)."
      analyses={urlAnalyses}
      getValue={(analysis) => analysis.title}
      renderValue={(value) => (
        <div>
          <div>{value}</div>
          {value && <div className="text-sm text-gray-500">({String(value).length} caracteres)</div>}
        </div>
      )}
    />

    <CompetitiveMetricRow
      label="Meta Description"
      description="Meta description da página."
      analyses={urlAnalyses}
      getValue={(analysis) => analysis.meta_description}
      renderValue={(value) => (
        <div>
          <div>{value}</div>
          {value && <div className="text-sm text-gray-500">({String(value).length} caracteres)</div>}
        </div>
      )}
    />

    <CompetitiveMetricRow
      label="Tamanho do Conteúdo"
      description="Quantidade de caracteres no conteúdo principal da página."
      analyses={urlAnalyses}
      getValue={(analysis) => analysis.content_length}
      getBestMetric={(value, bestValue) => typeof value === 'number' && value > bestValue}
    />
  </>
);